export function FormatDateValue (d: Date | null | undefined): string {
  if (d === undefined || d === null) {
    return ''
  } else {
    const dateVal = new Date(d)
    const datestring = `${(dateVal.getMonth() + 1)}/${dateVal.getDate()}/${dateVal.getFullYear()}`
    return datestring
  }
}

export function FormatDateTimeValue (d: Date | null | undefined): string {
  if (d === undefined || d === null) {
    return ''
  } else {
    const dateVal = new Date(d)
    const datestring = `${(dateVal.getMonth() + 1)}/${dateVal.getDate()}/${dateVal.getFullYear()} ${dateVal.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`
    return datestring
  }
}
export function FormatLongDate (date: Date | null): string {
  if (date === undefined || date === null) {
    return ''
  } else {
    const dateVal = new Date(date)
    const options: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'long', day: 'numeric' }
    return dateVal.toLocaleDateString('en-US', options)
  }
}

export function BirthdayToAgeInYearsAndMonths (d: Date | null | undefined, isDueDate: boolean): string {
  if (d === undefined || d === null) {
    return ''
  } else {
    const dateVal = new Date(d)
    const today = new Date()
    const years = today.getFullYear() - dateVal.getFullYear()
    const months = today.getMonth() - dateVal.getMonth()
    const days = today.getDate() - dateVal.getDate()
    if (isDueDate) {
      return `Due in ${years}y ${Math.abs(months)}m`
    }
    if (months < 0 || (months === 0 && days < 0)) {
      return `${years - 1}y ${12 + months}m`
    } else {
      return `${years}y ${months}m`
    }
  }
}

export function FormatDateAsTimeAgo (d: Date): string {
  const dateVal = new Date(d)
  const seconds = Math.floor((Date.now() - dateVal.getTime()) / 1000)

  let interval = Math.floor(seconds / 31536000)
  if (interval === 1) {
    return '1 year ago'
  } else if (interval > 1) {
    return interval.toString() + ' years ago'
  }

  interval = Math.floor(seconds / 2592000)
  if (interval === 1) {
    return '1 month ago'
  } else if (interval > 1) {
    return interval.toString() + ' months ago'
  }

  interval = Math.floor(seconds / 86400)
  if (interval === 1) {
    return '1 day ago'
  } else if (interval > 1) {
    return interval.toString() + ' days ago'
  }

  interval = Math.floor(seconds / 3600)
  if (interval === 1) {
    return '1 hour ago'
  } else if (interval > 1) {
    return interval.toString() + ' hours ago'
  }

  interval = Math.floor(seconds / 60)
  if (interval === 1) {
    return '1 minute ago'
  } else if (interval > 1) {
    return interval.toString() + ' minutes ago'
  }

  if (seconds < 10) {
    return 'just now'
  }

  return Math.floor(seconds).toString() + ' seconds ago'
}

export function AgeFromDate (dob: Date | null | undefined): number {
  if (dob === undefined || dob === null) {
    return 0
  } else {
    const dateVal = new Date(dob)
    const today = new Date()
    let age: number = today.getFullYear() - dateVal.getFullYear()
    const m: number = today.getMonth() - dateVal.getMonth()
    if (m < 0 || (m === 0 && today.getDate() < dateVal.getDate())) {
      age--
    }
    return age
  }
}

export function FormatTimeAs12Hour (time: string): string {
  const timeParts = time.split(':')
  const hours = parseInt(timeParts[0])
  const minutes = parseInt(timeParts[1])
  const ampm = hours >= 12 ? 'PM' : 'AM'
  const hours12 = hours % 12 > 0 ? hours % 12 : 12
  return `${hours12}:${minutes.toString().padStart(2, '0')} ${ampm}`
}

export function FormatCurrency (amount: number | null, noSymbol?: boolean): string {
  if (amount == null) {
    return ''
  } else if (noSymbol === undefined || !noSymbol) {
    const numVal = Number(amount)

    return '$' + numVal.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  } else {
    const numVal = Number(amount)
    return numVal.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  }
}

export function FormatBoolean (value: boolean | null): string {
  if (value === undefined || value === null) {
    return ''
  } else if (value) {
    return 'Yes'
  } else {
    return 'No'
  }
}

export function ScrollModalToTop (): void {
  // scroll the contents of a modal dialog to the top.  Can be used make sure errors listed at the top are displayed
  const modalDiv = document.getElementsByClassName('MuiDialogContent-root')
  if (modalDiv.length !== 0) {
    modalDiv[0].scrollTop = 0
  }
}

export function FileNameFromS3Key (key: string | null): string {
  if (key === null) {
    return ''
  } else {
    return key.substring(37)
  }
}

export function SpaceBeforeCapitals (s: string): string {
  return s.replace(/([A-Z])/g, ' $1').trim()
}

export function DownloadDocument (documentId: number | undefined): boolean {
  if (documentId !== undefined) {
    const encodedUri = `${process.env.REACT_APP_SERVER_URL ?? ''}/Document/DownloadFile/${documentId.toString()}`
    const link = document.createElement('a')
    link.setAttribute('target', '_blank')
    link.setAttribute('href', encodedUri)
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    return true
  }
  return false
}

export function TryFormatPhoneNumber (value: string | null): string {
  if (value === null || value === undefined) {
    return ''
  } else {
    value = value.trim()
    if (value.length === 10) {
      return `(${value.substring(0, 3)}) ${value.substring(3, 6)}-${value.substring(6)}`
    } else {
      return value
    }
  }
}

export async function DownloadFileFromPost (url: string, data: any, fileName: string): Promise<void> {
  // call a post endpoint that return a file object and download it
  await fetch(`${process.env.REACT_APP_SERVER_URL ?? ''}${url}`, {
    method: 'POST',
    headers: {
      'content-type': 'application/json'
    },
    body: JSON.stringify(data),
    credentials: 'include'
  })
    .then(async (response) => {
      if (response.status === 204) {
        alert('No data was returned for the criteria you selected')
      } else if (response.status === 400) {
        alert('The request could not be processed')
      } else {
        return await response.blob()
      }
    })
    .then((blob) => {
      if (blob !== undefined) {
        // Create blob link to download
        const url = window.URL.createObjectURL(
          new Blob([blob])
        )
        const link = document.createElement('a')
        link.href = url
        link.setAttribute(
          'download',
          fileName
        )

        // Append to html link element page
        document.body.appendChild(link)

        // Start download
        link.click()
        link.remove()
      }
    })
}

export function CurrentSchoolYear (): number {
  // reminder that getMonth() returns 0-11
  return (new Date().getMonth() + 1 >= 7 ? new Date().getFullYear() : new Date().getFullYear() - 1)
}

export function IsValidEmail (email: string): boolean {
  const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return emailRegex.test(email)
}
